/* import __COLOCATED_TEMPLATE__ from './dismiss-read.hbs'; */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";

export default class DismissRead extends Component {
  @tracked dismissTopics = false;
}
